import React, { useState, useEffect } from "react";

const BlogSearch = ({ searchQuery, selectedCategory, onSearchChange, onCategoryChange }) => {
  const [inputValue, setInputValue] = useState("");

  // More generic categories that can encompass more blogs as they grow
  const categories = ["All Posts", "Camping & Outdoors", "Travel Guides", "Tips & Advice", "Destinations", "Van Life"];

  // Update input value when searchQuery prop changes
  useEffect(() => {
    setInputValue(searchQuery);
  }, [searchQuery]);

  // Handle search input changes with debouncing
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      onSearchChange(inputValue);
    }, 300); // 300ms debounce

    return () => clearTimeout(timeoutId);
  }, [inputValue, onSearchChange]);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleCategoryClick = (category) => {
    const categoryValue = category === "All Posts" ? "" : category;
    onCategoryChange(categoryValue);
  };

  const handleClearSearch = () => {
    setInputValue("");
    onSearchChange("");
  };

  return (
    <div className="blog-search-container">
      <div className="blog-search-header">
        <div className="blog-search-title-section">
          <div className="blog-search-title">Latest Blog Posts</div>
          <div className="blog-search-subtitle">
            Choose a category to quickly find the posts that match your journey.
          </div>
        </div>
        <div className="blog-search-controls">
          <div className="blog-search-bar">
            <div className="blog-search-input-container">
              <div className="blog-search-content">
                <input
                  type="text"
                  className="blog-search-input"
                  placeholder="Search articles..."
                  value={inputValue}
                  onChange={handleInputChange}
                />
                {inputValue && (
                  <button
                    className="blog-search-clear"
                    onClick={handleClearSearch}
                    type="button"
                  >
                    ×
                  </button>
                )}
              </div>
              <div className="blog-search-icon">
                <svg
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.5 21L18.0001 17.5M20.5 11.5C20.5 16.1944 16.6944 20 12 20C7.30558 20 3.5 16.1944 3.5 11.5C3.5 6.80558 7.30558 3 12 3C16.6944 3 20.5 6.80558 20.5 11.5Z"
                    stroke="#009B31"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
            </div>
          </div>
          <div className="blog-category-chips">
            {categories.map((category) => (
              <div
                key={category}
                className={`blog-chip ${
                  (category === "All Posts" && !selectedCategory) ||
                  category === selectedCategory
                    ? "blog-chip-active"
                    : ""
                }`}
                onClick={() => handleCategoryClick(category)}
                style={{ cursor: "pointer" }}
              >
                <div className="blog-chip-text">{category}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogSearch;
